module.exports = __webpack_public_path__ + "static/img/3sing.7d82c08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ss/3sing.png
// module id = kndA
// module chunks = 1